import React from "react";

interface DevOnlyProps {
    children: React.ReactNode;
    className?: string;
    visible?: boolean;
}

const DevOnly: React.FC<DevOnlyProps> = ({ children, className, visible }) => {
    if (visible === undefined ? !import.meta.env.DEV : !visible) {
        return null;
    }
    if (!children) {
        return null;
    }
    const mergedClassName = `text-xs opacity-80 ${className ?? ""}`.trim();
    return <span className={mergedClassName}>🚧 {children}</span>

};

export default DevOnly;
